/**
 * زیرمنوهای مجاز هر ماژول — از آبجکت modules در پاسخ POST /auth/login
 * مثال: { work: ["projects", "tasks", "timeLogs"], hr: ["leaves", "attendance"] }
 */

/** کلید activeMenu سایدبار → کلید modules در پاسخ لاگین */
export const SIDEBAR_TO_LOGIN_MODULE = {
  work: 'work',
  hr: 'hr',
  leads: 'lead',
  finance: 'finance',
  tickets: 'tickets',
  'call-center': 'callcenter',
  'live-chat': 'livechat',
  calendar: 'myCalendar',
  notices: 'noticeBoard',
  messages: 'messages',
  dashboard: 'dashboard',
  settings: 'settings',
  reports: 'reports',
  events: 'events',
  clients: 'clients',
  products: 'products',
  orders: 'orders',
};

/** کلید کارت ماژول در داشبورد → کلید modules در پاسخ لاگین */
export const DASHBOARD_TO_LOGIN_MODULE = {
  'dashboard-module': 'dashboard',
  leads: 'lead',
  customers: 'clients',
  products: 'products',
  orders: 'orders',
  work: 'work',
  tickets: 'tickets',
  'call-center': 'callcenter',
  'live-chat': 'livechat',
  finance: 'finance',
  calendar: 'myCalendar',
  hr: 'hr',
  notices: 'noticeBoard',
  messages: 'messages',
  reports: 'reports',
  settings: 'settings',
  action: null,
};

/** نگاشت module قدیمی UI → کلید modules لاگین (برای isModuleActive) */
export const UI_MODULE_TO_LOGIN_KEY = {
  leads: 'lead',
  clients: 'clients',
  products: 'products',
  orders: 'orders',
  tasks: 'work',
  projects: 'work',
  contracts: 'work',
  timelogs: 'work',
  tickets: 'tickets',
  callcenter: 'callcenter',
  livechat: 'livechat',
  events: 'myCalendar',
  notices: 'noticeBoard',
  messages: 'messages',
  employees: 'hr',
  attendance: 'hr',
  leaves: 'hr',
  holidays: 'hr',
  shift: 'hr',
  expenses: 'finance',
  payments: 'finance',
  bankaccount: 'finance',
  estimates: 'finance',
  invoices: 'finance',
  reports: 'reports',
};

const normalizeMenuKey = (value) =>
  String(value || '')
    .trim()
    .replace(/[_-]/g, '')
    .toLowerCase();

/** نرمال‌سازی کلید submenu (مثلاً timeLogs ↔ timelogs) */
export const normalizeLoginMenuKey = (key) => {
  const n = normalizeMenuKey(key);
  const aliases = {
    timelogs: 'timelogs',
    leadforms: 'leadforms',
    bankaccounts: 'bankaccounts',
    bankaccount: 'bankaccounts',
    recurringexpenses: 'recurringexpenses',
    pettycash: 'expenses',
    paymentgateway: 'paymentgateway',
    invoicesettings: 'invoicesettings',
    profilesettings: 'profilesettings',
    projecttemplates: 'projects',
    contracttemplates: 'contracts',
    leavesettings: 'leaves',
    attendancesettings: 'attendance',
    ticketform: 'tickets',
    deal: 'deals',
    privatedashboard: 'privatedashboard',
    advanceddashboard: 'advanceddashboard',
    mycalendar: 'mycalendar',
    noticeboard: 'noticeboard',
    appreciation: 'appreciation',
  };
  return aliases[n] || n;
};

/** مسیر زیرمنو → کلید submenu در modules */
export const resolveSidebarSubmenuKey = (path) => {
  if (!path) return null;

  if (path.startsWith('/work/tasks') || path.startsWith('/work/settings')) return 'tasks';
  if (path.startsWith('/work/projects/templates')) return 'projects';
  if (path.startsWith('/work/projects')) return 'projects';
  if (path.startsWith('/work/time-logs') || path.startsWith('/work/timelogs')) return 'timeLogs';
  if (path.startsWith('/work/contracts/templates')) return 'contracts';
  if (path.startsWith('/work/contracts')) return 'contracts';

  if (path === '/hr/dashboard' || path.startsWith('/hr/dashboard')) return 'dashboard';
  if (path === '/hr/departments') return 'departments';
  if (path === '/hr/positions') return 'designations';
  if (path === '/hr/employees') return 'employees';
  if (path === '/hr/shifts') return 'shifts';
  if (path === '/hr/leaves') return 'leaves';
  if (path === '/hr/attendance') return 'attendance';
  if (path === '/hr/attendance-regularizations') return 'attendance';
  if (path === '/hr/holidays') return 'holidays';
  if (path === '/hr/leaves-settings') return 'leaves';
  if (path === '/hr/attendance-settings') return 'attendance';
  if (path.startsWith('/hr/appreciation')) return 'appreciation';

  if (path === '/finance/bank-accounts' || path.startsWith('/finance/bank-accounts')) return 'bankAccounts';
  if (path === '/finance/expenses' || path.startsWith('/finance/expenses')) return 'expenses';
  if (path === '/finance/recurring-expenses' || path.startsWith('/finance/recurring-expenses')) return 'recurringExpenses';
  if (path === '/finance/petty-cash' || path.startsWith('/finance/petty-cash')) return 'expenses';
  if (path === '/finance/estimates' || path.startsWith('/finance/estimates')) return 'estimates';
  if (path === '/finance/invoices' || path.startsWith('/finance/invoices')) return 'invoices';
  if (path === '/finance/payment-gateway') return 'paymentGateway';
  if (path === '/finance/tax') return 'tax';
  if (path === '/finance/invoice-settings') return 'invoiceSettings';
  // هر آیتم منوی مالی دسترسی مجزا دارد (app/Support/Finance/FinancePermissions.php در بک‌اند)
  if (path === '/finance/register-payment') return 'registerPayment';
  if (path === '/finance/transactions') return 'transactions';
  if (path === '/finance/approvals') return 'approvals';
  if (path === '/finance/cheques') return 'cheques';
  if (path === '/finance/dashboard') return 'financeDashboard';
  if (path === '/finance/aging-report' || path === '/finance/monthly-checklist') return 'agingReport';
  if (path === '/finance/audit-logs') return 'auditLogs';
  if (path === '/finance/receivables-summary') return 'agingReport';
  if (path === '/finance/refunds') return 'refunds';
  if (path === '/finance/discount-limits') return 'discountLimits';
  if (path === '/finance/targets') return 'targets';
  if (path === '/finance/commission-plans') return 'commissionPlans';
  if (path === '/finance/payroll') return 'payroll';
  if (path === '/finance/client-profile' || path.startsWith('/finance/client-profile')) return 'clientProfile';

  if (path === '/leads') return 'leads';
  if (path === '/leads/deals') return 'deals';
  if (path.startsWith('/leads/lead-forms')) return 'leadForms';
  if (path.startsWith('/leads/reports')) return 'reports';
  if (path.startsWith('/leads/settings')) return 'settings';

  if (path.startsWith('/clients')) return 'clients';
  if (path.startsWith('/products')) return 'products';
  if (path.startsWith('/orders')) return 'orders';

  if (path.startsWith('/tickets/ticket-form')) return 'ticketForm';
  if (path.startsWith('/tickets/settings')) return 'ticketSettings';
  if (path.startsWith('/tickets/add')) return 'tickets';
  if (path.startsWith('/tickets')) return 'tickets';

  if (path.startsWith('/call-center/dashboard')) return 'dashboard';
  if (path.startsWith('/call-center/live')) return 'live';
  if (path.startsWith('/call-center/calls')) return 'calls';
  if (path.startsWith('/call-center/agents')) return 'agents';
  if (path.startsWith('/call-center/queues')) return 'queues';
  if (path.startsWith('/call-center/outcomes')) return 'outcomes';
  if (path.startsWith('/call-center/subjects')) return 'subjects';
  if (path.startsWith('/call-center/objections')) return 'objections';
  if (path.startsWith('/call-center/standards')) return 'standards';
  if (path.startsWith('/call-center/reports')) return 'reports';
  if (path.startsWith('/call-center/fake-call')) return 'fake-call';
  if (path.startsWith('/call-center/settings')) return 'settings';
  if (path.startsWith('/call-center')) return 'callcenter';

  if (path.startsWith('/knowledge-base')) return 'knowledgebase';

  if (path.startsWith('/live-chat/operators')) return 'operators';
  if (path.startsWith('/live-chat/dashboard')) return 'dashboard';
  if (path.startsWith('/live-chat/sub-departments')) return 'sub-departments';
  if (path.startsWith('/live-chat/auto-replies')) return 'auto-replies';
  if (path.startsWith('/live-chat/departments')) return 'departments';
  if (path.startsWith('/live-chat/settings')) return 'settings';
  if (path.startsWith('/live-chat/test')) return 'test';
  if (path.startsWith('/live-chat')) return 'inbox';

  if (path.startsWith('/notices/add')) return 'notices';
  if (path.startsWith('/notices')) return 'notices';
  if (path.startsWith('/messages')) return 'messages';
  if (path.startsWith('/calendar')) return 'myCalendar';
  if (path.startsWith('/reports')) return 'reports';

  if (path === '/dashboard/private') return 'privateDashboard';
  if (path === '/dashboard/advanced') return 'advancedDashboard';
  if (path === '/dashboard/super-admin') return 'superAdminDashboard';

  if (path === '/settings/profile-settings') return 'profileSettings';
  if (path === '/settings/company') return 'companySettings';
  if (path === '/settings/business-address') return 'businessAddress';
  if (path === '/settings/currency-settings') return 'currencySettings';
  if (path === '/settings/app-settings') return 'appSettings';
  if (path === '/settings/role-permissions') return 'rolePermissions';

  if (path.startsWith('/action/')) {
    if (path.includes('notifications/settings')) return 'notificationSettings';
    if (path.includes('notifications')) return 'notifications';
    if (path.includes('my-actions')) return 'myActions';
    if (path.includes('create')) return 'create';
    if (path.includes('reports')) return 'reports';
    return 'dashboard';
  }

  return null;
};

export const flattenLoginModuleMenus = (modulesPayload) => {
  if (!modulesPayload) return [];
  if (Array.isArray(modulesPayload)) return modulesPayload;
  if (typeof modulesPayload === 'object') {
    return [...new Set(Object.values(modulesPayload).flat().filter(Boolean))];
  }
  return [];
};

/** تبدیل modules لاگین به moduleMenus + لیست تخت برای سازگاری */
export const parseLoginModules = (modulesPayload) => {
  if (!modulesPayload) {
    return { moduleMenus: null, activeModules: [] };
  }
  if (Array.isArray(modulesPayload)) {
    return { moduleMenus: null, activeModules: modulesPayload };
  }
  if (typeof modulesPayload === 'object') {
    return {
      moduleMenus: modulesPayload,
      activeModules: flattenLoginModuleMenus(modulesPayload),
    };
  }
  return { moduleMenus: null, activeModules: [] };
};

const resolveLoginModuleKey = (uiKey) =>
  DASHBOARD_TO_LOGIN_MODULE[uiKey] ??
  SIDEBAR_TO_LOGIN_MODULE[uiKey] ??
  UI_MODULE_TO_LOGIN_KEY[uiKey] ??
  uiKey;

/** آیا ماژول در پاسخ لاگین برای کاربر فعال است؟ (حتی با آرایه خالی) */
export const isLoginModuleEnabled = (uiModuleKey, moduleMenus) => {
  if (!moduleMenus || typeof moduleMenus !== 'object' || Array.isArray(moduleMenus)) {
    return null;
  }

  const loginKey = resolveLoginModuleKey(uiModuleKey);
  if (loginKey == null) return true;

  return Object.prototype.hasOwnProperty.call(moduleMenus, loginKey);
};

/** آیا نام ماژول UI (مثل tasks، orders، events) برای کاربر فعال است؟ */
export const isLoginUiModuleActive = (moduleName, moduleMenus, activeModules = []) => {
  if (!moduleName) return true;

  if (moduleMenus && typeof moduleMenus === 'object' && !Array.isArray(moduleMenus)) {
    if (activeModules.includes(moduleName)) return true;

    const loginKey = UI_MODULE_TO_LOGIN_KEY[moduleName] || moduleName;
    if (Object.prototype.hasOwnProperty.call(moduleMenus, loginKey)) return true;
    if (Object.prototype.hasOwnProperty.call(moduleMenus, moduleName)) return true;

    return Object.values(moduleMenus).some(
      (items) =>
        Array.isArray(items) &&
        items.some((item) => normalizeLoginMenuKey(item) === normalizeLoginMenuKey(moduleName)),
    );
  }

  return activeModules.includes(moduleName);
};

/** آیا زیرمنوی سایدبار برای کاربر مجاز است؟ */
export const isLoginSubmenuAllowed = (sidebarKey, path, moduleMenus) => {
  if (!moduleMenus || typeof moduleMenus !== 'object' || Array.isArray(moduleMenus)) {
    return true;
  }

  const loginModuleKey = SIDEBAR_TO_LOGIN_MODULE[sidebarKey] ?? DASHBOARD_TO_LOGIN_MODULE[sidebarKey];
  if (!loginModuleKey) return true;

  if (!Object.prototype.hasOwnProperty.call(moduleMenus, loginModuleKey)) return false;

  const allowed = moduleMenus[loginModuleKey];
  if (!Array.isArray(allowed)) return true;
  // آرایه خالی = ماژول فعال، بدون محدودیت زیرمنو
  if (allowed.length === 0) return true;

  if (sidebarKey === 'hr' && (path === '/hr/dashboard' || path === '/hr')) {
    return true;
  }

  const submenuKey = resolveSidebarSubmenuKey(path);
  if (!submenuKey) return false;

  const normalizedItem = normalizeLoginMenuKey(submenuKey);
  return allowed.some((key) => normalizeLoginMenuKey(key) === normalizedItem);
};
